import { writable, readable } from 'svelte/store'
import { Deferred } from 'src/shared/Deferred'

export const login = writable(null);

export const map = writable(null);
export const map2 = readable(new Deferred());

export const filter = writable(null);
export const detailsMenu = writable(null);

export const modal = writable({});
export const help = writable({public:{},publicReview:{},privateReview:{},'parts/codes':{}});

export const esri = writable({});

export const admin = writable({});
export const publicStore = writable({});

export const reviews = writable({limitations:{}});
export const limitations = writable({});
